import { createContext } from 'react';
import initialLanguageState from './initialLanguageState';

const LanguageContext = createContext(initialLanguageState);

export default LanguageContext;
